import { VisibilityHandler } from './components/visibility-handler'
import { useHandleCallSounds } from '$logic/call'
import { useIsDesktopSize } from '$common/react-hooks/layout'
import { ProfileCompletionModal } from '$comp/modals/profile-completion'

export function SjfSignup() {
  useHandleCallSounds()

  const isDesktopSize = useIsDesktopSize()
  if (isDesktopSize) return <ProfileCompletionModal />
  return (
    <VisibilityHandler zIndex={3}>
      <ProfileCompletionModal />
    </VisibilityHandler>
  )
}
